(() => {
  document.querySelectorAll('[data-catalog]').forEach((root) => {
    const panel = root.querySelector('[data-catalog-panel]');
    const openButton = root.querySelector('[data-catalog-open]');
    const closeButtons = root.querySelectorAll('[data-catalog-close]');
    const sort = root.querySelector('[data-catalog-sort]');
    const form = root.querySelector('.catalog-filters');
    const grid = root.querySelector('.product-grid--catalog');
    const pagination = root.querySelector('.pagination');
    const mobile = window.matchMedia('(max-width: 900px)');
    const returnKey = 'eclat:catalog-return';
    const restoreKey = 'eclat:catalog-restore';

    let loadedPages = 1;
    let loadingNext = false;
    let nextUrl = pagination?.querySelector('.next a')?.href || '';
    let loadingLabel = null;

    const saveReturnPosition = () => {
      try {
        sessionStorage.setItem(returnKey, JSON.stringify({ url: window.location.href, scrollY: window.scrollY, pagesLoaded: loadedPages, savedAt: Date.now() }));
        sessionStorage.removeItem(restoreKey);
      } catch (error) {}
    };

    const bindProductLinks = (scope = root) => {
      scope.querySelectorAll('.product-card__link:not([data-catalog-return-bound])').forEach((link) => {
        link.dataset.catalogReturnBound = 'true';
        link.addEventListener('click', saveReturnPosition);
      });
    };

    bindProductLinks();
    const getNextUrlFromDocument = (doc) => doc.querySelector('[data-catalog] .pagination .next a')?.href || '';

    const loadNextPage = async () => {
      if (!grid || !nextUrl || loadingNext) return false;
      loadingNext = true;
      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = doc.querySelector('[data-catalog] .product-grid--catalog');
        if (!incomingGrid) throw new Error('Catalog grid missing from next page');
        [...incomingGrid.children].forEach((card) => grid.appendChild(card));
        loadedPages += 1;
        bindProductLinks(grid);
        nextUrl = getNextUrlFromDocument(doc);
        return true;
      } catch (error) {
        if (pagination) pagination.hidden = false;
        return false;
      } finally {
        loadingNext = false;
      }
    };

    const loadEntireCatalog = async () => {
      if (!grid || !nextUrl) return;
      if (pagination) pagination.hidden = true;
      loadingLabel = document.createElement('p');
      loadingLabel.className = 'catalog-infinite-loading';
      loadingLabel.setAttribute('role', 'status');
      loadingLabel.setAttribute('aria-live', 'polite');
      loadingLabel.textContent = 'Caricamento della collezione…';
      pagination?.insertAdjacentElement('beforebegin', loadingLabel);
      while (nextUrl) {
        const loaded = await loadNextPage();
        if (!loaded) break;
      }
      loadingLabel?.remove();
      if (!nextUrl && pagination) pagination.hidden = true;
    };

    const restoreCatalog = async () => {
      let saved = null;
      let shouldRestore = false;
      try {
        saved = JSON.parse(sessionStorage.getItem(returnKey) || 'null');
        shouldRestore = sessionStorage.getItem(restoreKey) === 'true';
      } catch (error) {}
      const sameUrl = saved?.url && new URL(saved.url).href === window.location.href;
      if (sameUrl && shouldRestore) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        const pagesToRestore = Math.max(1, Number(saved.pagesLoaded) || 1);
        while (loadedPages < pagesToRestore && nextUrl) {
          const loaded = await loadNextPage();
          if (!loaded) break;
        }
        const restorePosition = () => window.scrollTo(0, Number(saved.scrollY) || 0);
        requestAnimationFrame(() => requestAnimationFrame(restorePosition));
        window.addEventListener('load', restorePosition, { once: true });
        try { sessionStorage.removeItem(restoreKey); } catch (error) {}
      }
      await loadEntireCatalog();
    };

    restoreCatalog();

    const setOpen = (open) => {
      if (!panel) return;
      const shouldOpen = mobile.matches && open;
      root.classList.toggle('filters-open', shouldOpen);
      panel.classList.toggle('is-open', shouldOpen);
      panel.setAttribute('aria-hidden', String(mobile.matches && !shouldOpen));
      panel.inert = mobile.matches && !shouldOpen;
      openButton?.setAttribute('aria-expanded', String(shouldOpen));
      document.body.classList.toggle('catalog-locked', shouldOpen);
    };

    openButton?.addEventListener('click', () => setOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    sort?.addEventListener('change', () => form?.requestSubmit());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('filters-open')) setOpen(false);
    });

    const syncViewport = () => {
      if (mobile.matches) setOpen(false);
      else {
        panel?.classList.remove('is-open');
        panel?.setAttribute('aria-hidden', 'false');
        if (panel) panel.inert = false;
        document.body.classList.remove('catalog-locked');
      }
    };

    mobile.addEventListener?.('change', syncViewport);
    syncViewport();
  });
})();
